class EventsLibraryCheckCollection extends App.Collections.BaseCollection {
    url = 'EventLibrary/checks/list';
    model = App.Models.EventLibrary;
}
App.Collections.EventsLibraryCheck = EventsLibraryCheckCollection;

class EventsLibraryActionCollection extends App.Collections.BaseCollection {
    url = 'EventLibrary/actions/list';
    model = App.Models.EventLibrary;
}
App.Collections.EventsLibraryAction = EventsLibraryActionCollection;
